import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Phone, Envelope, WhatsappLogo, Headset } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const META = {
  phone:    { icon: Phone,        label: 'Call',     href: (v) => `tel:${v.replace(/\s/g,'')}` },
  email:    { icon: Envelope,     label: 'Email',    href: (v) => `mailto:${v}` },
  whatsapp: { icon: WhatsappLogo, label: 'WhatsApp', href: (v) => `https://wa.me/${v.replace(/[^0-9]/g,'')}` },
};

/**
 * Compact help widget rendered in the bottom-right of buyer/seller pages.
 * Renders only the channels the admin marked active+show_to_public.
 */
const HelplineWidget = () => {
  const [helpline, setHelpline] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API_URL}/api/platform/helpline`);
        if (!cancelled) setHelpline(res.data?.helpline || {});
      } catch (e) { /* ignore */ }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!helpline) return null;
  const keys = Object.keys(helpline).filter(k => helpline[k]);
  if (keys.length === 0) return null;

  return (
    <div className="fixed bottom-5 right-5 z-40" data-testid="helpline-widget">
      {open && (
        <div className="mb-2 bg-white rounded-2xl shadow-xl border border-slate-200 p-3 min-w-[220px]" data-testid="helpline-panel">
          <div className="text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-2 px-1">Need help?</div>
          <div className="space-y-1">
            {keys.map(k => {
              const m = META[k];
              if (!m) return null;
              const Icon = m.icon;
              return (
                <a key={k} href={m.href(helpline[k])} target={k === 'whatsapp' ? '_blank' : undefined}
                  rel="noopener noreferrer"
                  data-testid={`helpline-${k}-link`}
                  className="flex items-center gap-2.5 px-2 py-2 rounded-lg hover:bg-slate-50 transition-colors">
                  <Icon size={18} className="text-indigo-500" weight="fill" />
                  <div className="flex-1 min-w-0">
                    <div className="text-[11px] text-slate-500">{m.label}</div>
                    <div className="text-sm font-medium text-slate-900 truncate">{helpline[k]}</div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen(s => !s)}
        data-testid="helpline-toggle-btn"
        className="w-12 h-12 rounded-full bg-indigo-600 hover:bg-indigo-700 text-white shadow-lg shadow-indigo-500/40 flex items-center justify-center transition-transform hover:scale-105"
        aria-label="Helpline">
        <Headset size={22} weight="fill" />
      </button>
    </div>
  );
};

export default HelplineWidget;
